import { render } from "./Page.vue?vue&type=template&id=b7ecf358"
import script from "./Page.vue?vue&type=script&lang=js"
export * from "./Page.vue?vue&type=script&lang=js"

import exportComponent from "D:\\software\\jenkins_home\\.jenkins\\workspace\\dev\\vls\\html\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__